import React, { useMemo } from 'react';
import { useProfileQuery, UserPreferences } from '../../graphql/types';

export const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

export const USDollarWithSign = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  signDisplay: 'always'
});

export const USDollarCompact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

export const USDollarTwoDecimals= new Intl.NumberFormat('en-US', {
  notation: 'compact',
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export const USDollarNoDecimals = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
export const USDollarOneDecimals = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1
});

export function DailyCollectionUSDFormat(value: number) {
  return value < 1000 ? USDollarTwoDecimals.format(value) : USDollarCompact.format(value);
};

export const CurrencyText = ({ value, forceTwoDecimals }: { value: number; forceTwoDecimals?: boolean }) => {
  const { data, loading, refetch } = useProfileQuery({ fetchPolicy: 'cache-first' });
  const preferences = useMemo(() => data?.profile.preferences as UserPreferences, [data]);
  const raw = USDollar.format(value);
  let formatted: string;
  if (forceTwoDecimals) {
    formatted = raw;
  } else if (preferences?.showTrailingZeros) {
    formatted = raw;
  } else {
    formatted = raw.replace(/\.0+$/, '');
  }

  return <span dir="ltr">{formatted}</span>;
};
